module.exports = __webpack_public_path__ + "media/images/iconBell-8d029f402b0fb3d790203d9de1295c50.png";